'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { useApp } from '@/forApp/states/appState/appState';
import type { UserT } from '@/forApp/types/Entity';
import Button from '@/shared/Buttons/Button';
import ImageWithLoader from './../../../shared/Image/ImageWithLoader';
import styles from './styles.module.css';
import { formatPhone } from '@/forApp/utils/formatPhone';

type AgentInfoProps = {
  agent: UserT;
  isMobile?: boolean;
};

export const AgentInfo: React.FC<AgentInfoProps> = ({ agent, isMobile }) => {
  const [phoneShow, setPhoneShow] = useState<boolean>(false);
  const { addModal } = useApp();
  const pathname = usePathname();

  const openModalClickCall = () => {
    addModal({
      name: 'ConsultationModal',
      from: pathname,
      title: 'Заказать звонок',
    });
  };

  const phone = agent.phone ?? agent.agency.phone;

  const onClickCall = () => {
    if (!phoneShow) {
      setPhoneShow(true);
    } else {
      window.location.href = `tel:${phone}`;
    }
  };

  return (
    <div className={isMobile ? styles.agentMobileInfo : ''}>
      <div className={styles.agentInfo}>
        <div className={styles.agentAvatar}>
          <ImageWithLoader
            src={agent.photo_path ? agent.photo_path : '/imgs/user.png'}
            alt={agent.name}
            width={60}
            height={60}
            className={styles.avatarImage}
            objectFit="cover"
            borderRadius={0}
          />
        </div>
        <div className={styles.agentDetails}>
          <div className={styles.agentName}>
            {agent.name + ' ' + agent.surname}
          </div>
          <div className={styles.agentRole}>{agent.role.title}</div>
        </div>
      </div>
      <div className={styles.btnAgencyWrp}>
        <Button
          className={styles.btnAgency}
          text={phoneShow ? formatPhone(phone) : 'Показать телефон'}
          onClick={onClickCall}
        />
        <Button
          className={styles.btnAgency}
          color={'white'}
          text={'Заказать звонок'}
          onClick={openModalClickCall}
        />
      </div>
    </div>
  );
};
